// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"40":"3578585bd37b9b8008c0","992":"a29ce42e938ed01bd2a9"}[chunkId] + ".chunk.js";
};